const ALLOCATING = ['AppfolioIntegrated', 'BilledThroughLivable', 'Convergent', 'CableInternet'];
// Cable/internet properties bill residents through Livable, only for internet.
const COLLECTING = ['BilledThroughLivable', 'CableInternet'];

/** Every report Livy can run in one click. The Reports tab, the greeting and the popular chips all read this. */
export const REPORTS = [{
  // Livable's own report (Reporting, Utility Allocation Export), over any months instead of one cycle.
  key: 'utility-allocation-export',
  title: 'Utility allocation export',
  description: 'Bill amount, deductions and allocated by property, for up to 24 months, with program efficiency. CSV or Excel.',
  category: 'Allocation',
  prompt: 'Run my utility allocation export for this year, by property, with program efficiency',
  tool: 'get_allocation_audit',
  types: ALLOCATING
}, {
  key: 'recovery',
  title: 'Recovery',
  description: 'What was charged, paid, unpaid and credited over a range.',
  category: 'Recovery',
  prompt: 'How much did we recover this year, by month?',
  tool: 'get_reimbursement_kpis',
  types: COLLECTING
}, {
  key: 'recovery-efficiency',
  title: 'Recovery efficiency',
  description: 'Paid as a share of charged, month by month, as a chart.',
  category: 'Recovery',
  prompt: 'Show my recovery efficiency by month for the last 6 months, as a chart',
  tool: 'get_reimbursement_kpis',
  types: COLLECTING
}, {
  key: 'reimbursement-receipt',
  title: 'Reimbursement receipt',
  description: 'One property’s month: billed, recovered, withheld and the lines behind it.',
  category: 'Recovery',
  prompt: 'Show the latest reimbursement receipt for my first property',
  tool: 'get_reimbursement_receipt',
  types: COLLECTING
}, {
  key: 'accounts-receivable',
  title: 'Accounts receivable',
  description: 'What residents owe now, by property and age.',
  category: 'Receivables',
  prompt: 'What do my residents owe right now, by property?',
  tool: 'get_accounts_receivable',
  types: COLLECTING
}, {
  key: 'convergent-export',
  title: 'Charge export',
  description: 'The charges your property management software imports, for one property and month.',
  category: 'Convergent',
  prompt: 'Show last month’s charge export for my first property',
  tool: 'get_convergent_charge_export',
  types: ['Convergent']
}];
export const CATEGORIES = ['Allocation', 'Recovery', 'Receivables', 'Convergent'];

/** The reports a customer type can run; before the type is known, the ones every allocating customer has. */
export const reportsFor = type => REPORTS.filter(r => r.types.includes(type !== null && type !== void 0 ? type : 'AppfolioIntegrated'));

/** The catalog report a tool answers, for "most run". */
export const reportForTool = (tool, type) => tool ? reportsFor(type).find(r => r.tool === tool) : undefined;